import { fromJS } from 'immutable';

const initialState = fromJS({
  open: false,
  customizedMessage: '',
  loading: false,
  finishedSendingEmail: false,
  includeNotes: false,
  contractId: '',
  updatePartnerForAllContracts: false,
  newEmails: [],
  updatedEmails: {},
  removedEmails: [],
  newPartnerName: '',
  removeContactFromPartner: false,
  to: {},
  contacts: [],
  toEmails: [],
  resendToEmails: [],
  partner: {
    contacts: [],
  },
});

export default function resendContractDialog(state = initialState, { type, payload }) {
  switch (type) {
    case 'CHANGE_RESEND_CONTRACT_DIALOG_STATE':
      return state.set('open', true)
             .merge(fromJS(payload));
    case 'GET_PARTNER_FOR_RESEND_DIALOG_SUCCESS':
      return state.set('partner', fromJS(payload.partners[0]));
    case 'UPDATE_CONTRACT_PARTNER_INFO_SUCCESS':
      return state.set('loading', false)
      .setIn(['to', 'name'], payload.newPartnerName || state.getIn(['to', 'name']))
      .setIn(['to', 'contactIds'], fromJS(payload.toContactIds))
      .set('toEmails', fromJS(payload.toEmails))
      .set('resendToEmails', fromJS(payload.resendToEmails.length ? payload.resendToEmails : payload.toEmails))
      .set('changesSaved', true);
    case 'CLOSE_RESEND_CONTRACT_DIALOG':
      return initialState;
    case 'ON_BCC_SELF_CHECK':
      return state.set('BCCToSelf', payload.checked);
    case 'INCLUDE_NOTES_CHECK':
      return state.set('includeNotes', payload.checked);
    case 'UPDATE_PROPS_RESEND_CONTRACT_REDUCER':
      return state.merge(fromJS(payload));
    case 'UPDATE_CONTRACT_PARTNER_INFO_STARTED':
      return state.set('loading', true);
    case 'UPDATE_CONTRACT_PARTNER_INFO_ERROR':
      return state.set('loading', false);
    case 'RESEND_CONTRACT_STARTING':
      return state.set('loading', payload);
    case 'RESEND_CONTRACT_FINISHED':
      return state.set('loading', false)
                  .set('finishedSendingEmail', true);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/contracting/dialogs/dialog-reducers/resend-contract-reducer.js